export type ClerkAppId = 'bloom' | 'ginione';

/**
 * Returns true when the dual-Clerk feature flag is enabled (default: ON).
 * Set NEXT_PUBLIC_ENABLE_DUAL_CLERK=false to force single-app (Bloom) mode.
 */
export function isDualClerkEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_DUAL_CLERK !== 'false';
}

/**
 * Determines which Clerk app the user is on based on hostname.
 * When the dual-Clerk flag is OFF, always returns 'bloom'.
 */
export function getClerkApp(): ClerkAppId {
  if (
    isDualClerkEnabled() &&
    typeof window !== 'undefined' &&
    window.location.hostname.includes('ginione.de')
  ) {
    return 'ginione';
  }
  return 'bloom';
}

/**
 * Returns true if the current domain is the Ginione app.
 */
export function isGinioneDomain(): boolean {
  return getClerkApp() === 'ginione';
}

const APP_ORIGINS: Record<ClerkAppId, string | undefined> = {
  bloom: process.env.NEXT_PUBLIC_BLOOM_ORIGIN,
  ginione: process.env.NEXT_PUBLIC_GINIONE_ORIGIN,
};

/**
 * Returns a full URL for the given app + path.
 * Falls back to a same-origin path when the env var is not set
 * (e.g. plain localhost:3000 without /etc/hosts entries).
 */
export function getAppUrl(app: ClerkAppId, path = '/'): string {
  const origin = APP_ORIGINS[app];
  if (origin) {
    return `${origin}${path}`;
  }
  return path;
}
